import { render, staticRenderFns } from "./editagent.vue?vue&type=template&id=4d55a882&scoped=true&"
import script from "./editagent.vue?vue&type=script&lang=js&"
export * from "./editagent.vue?vue&type=script&lang=js&"
import style0 from "./editagent.vue?vue&type=style&index=0&id=4d55a882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55a882",
  null
  
)

export default component.exports